<div class="container create-container">
    <kendo-card class="create-card" width="100%">
        <kendo-card-body>
            <div class="create-header">
                <div class="create-title">
                    <span class="create-title-label">New Request</span>
                    <span class="create-title-value">Create RTA</span>
                </div>
                <div class="create-status">
                    <span class="create-status-label">Status</span>
                    <span class="create-status-value">Draft</span>
                </div>
            </div>
            <div class="create-body">
                <p class="create-helper">
                    Provide the request basics below. You can add additional data after saving.
                </p>
                <app-basic-data></app-basic-data>
            </div>
        </kendo-card-body>
    </kendo-card>
    <kendo-floatingactionbutton class="create-fab" [title]="'save' | translate" [text]="'save' | translate"
        [positionMode]="'fixed'" (click)="onSave()">
    </kendo-floatingactionbutton>
</div>
